export const SEND_USER_REQUEST = "SEND_USER_REQUEST";
export const RECEIVE_USER_RESPONSE = "RECEIVE_USER_RESPONSE";
export const RECEIVE_USER_ERROR = "RECEIVE_USER_ERROR";

export const SET_IS_LOGIN = "SET_IS_LOGIN";
